import { DotCarousel } from '@theme/dot-carousel';

/**
 * <trust-bar> — progressive enhancement for the mobile single-card carousel of
 * the Trust bar widget. Desktop renders as a static evenly-spaced row via CSS
 * alone and needs no JS.
 *
 * Swipe + dots behaviour lives in the shared DotCarousel base; this only names
 * the widget's own hooks.
 */
class TrustBar extends DotCarousel {
  static scrollerSelector = '[data-trust-bar-scroller]';
  static dotsSelector = '[data-trust-bar-dots]';
  static dotClass = 'trust-bar__dot';
}

if (!customElements.get('trust-bar')) {
  customElements.define('trust-bar', TrustBar);
}
